import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import ListComponent from "@/components/listComponent"
import { MyContext } from "@/store/myContext"
import Detail from "./detail"
import { Modal, Image, Rate } from "antd"
import { storePage, storeDelete } from "@/service/storeManagement"
import TopSearch from "@/components/TopSearch"
import { fileLookUrl } from "@/config/app.js"
//访问列表
export default () => {
    
const { t } = useTranslation();
const { state, message } = useContext(MyContext)
    const [showVisible, setShowVisible] = useState(false)
    const [showMode, setShowMode] = useState("")
    const [list, setList] = useState([]) //列表
    const [searchValue, setSearchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标及信息

    useEffect(() => {
        if (state.activeMenu === "storeManagement") {
            loadData(pagination.current)
        }
    }, [state.activeMenu]) // eslint-disable-line react-hooks/exhaustive-deps

    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { disableFlag: 0, ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "storeName",
                    rule: "DESC",
                },
            ],
        }
        storePage(data).then((res) => {
            setpagination({
                current: current,
                total: res.retData.total,
                pageSize: 10,
            })
            setSelectInfo({ rowInfo: {}, rowIndex: -1 })
            setList(res.retData.list)
        })
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    //列表button
    const topButtons = [
        {
            click: () => handleDetails("insert"),
            content: t(`storeManagement.storeManagement.index.新增`),
        },
        {
            click: () => handleDetails("edit"),
            content: t(`storeManagement.storeManagement.index.编辑`),
        },
        {
            click: () => handleDelete(),
            content: t(`storeManagement.storeManagement.index.删除`),
        },
    ]

    //删除
    const handleDelete = async () => {
        if (!Object.keys(selectInfo.rowInfo).length) {
            message.warning(t(`storeManagement.storeManagement.index.请选择你要删除的门店`))
            return
        }
        Modal.confirm({
            content: `${t(`storeManagement.storeManagement.index.确定要删除`)}--${selectInfo.rowInfo.storeName}?`,
            okText: t(`storeManagement.storeManagement.index.确定`),
            cancelText: t(`storeManagement.storeManagement.index.取消`),
            centered: true,
            onOk() {
                storeDelete(selectInfo.rowInfo.id).then((res) => {
                    message.success(t(`storeManagement.storeManagement.index.删除成功`))
                    loadData(pagination.current, searchValue)
                })
            },
        })
    }
    //新增
    const handleDetails = async (mode) => {
        if (mode === "edit") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`storeManagement.storeManagement.index.请选择你要编辑的门店`))
                return
            }
        } else if (mode === "look") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`storeManagement.storeManagement.index.请选择你要查看的门店`))
                return
            }
        }
        setShowMode(mode)
        setShowVisible(true)
    }

    //table配置
    const columns = [
        {
            title: t(`storeManagement.storeManagement.index.门头`),
            align: "center",
            dataIndex: "storeThumbnail",
            render: (text) => (text ? <Image src={`${fileLookUrl().image}${text}`} width={68} height={34} key={text} /> : ""),
        },
        {
            title: t(`storeManagement.storeManagement.index.名称`),
            align: "center",
            dataIndex: "storeName",
        },
        {
            title: t(`storeManagement.storeManagement.index.等级`),
            align: "center",
            dataIndex: "storeGrade",
            render: (text) => <Rate allowHalf value={text || 0} disabled />,
        },
        {
            title: t(`storeManagement.storeManagement.index.地址`),
            align: "center",
            dataIndex: "storeAddress",
        },
        {
            title: t(`storeManagement.storeManagement.index.电话`),
            align: "center",
            dataIndex: "storePhone",
        },
    ]
    // 搜索JSON
    const searchList = {
        normalList: [
            {
                type: "input",
                placeholder: t(`storeManagement.storeManagement.index.请输入门店名称`),
                valueName: "storeName",
            },
        ],
    }

    return (
        <>
            {state.activeMenu === "storeManagement" && (
                <>
                    <TopSearch
                        title= {t(`storeManagement.storeManagement.index.门店管理`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title= {t(`storeManagement.storeManagement.index.门店管理`)}
                        buttons={topButtons}
                        selectInfo={selectInfo}
                        columns={columns}
                        dataSource={list}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        setSelectInfo={(obj) => setSelectInfo(obj)}
                        scroll={{ x: "max-content" }}
                    />

                    {showVisible && (
                        <Detail
                            rowInfo={selectInfo.rowInfo}
                            visible={showVisible}
                            mode={showMode}
                            setVisible={setShowVisible}
                            onSuccess={() => {
                                loadData(1, searchValue)
                            }}
                        />
                    )}
                </>
            )}
        </>
    )
}
